export default __webpack_public_path__ + "static/extrem-leise-und-vibrationsarm_boge-kompressoren-25b9718a64f7e08f5a48a13e783a7ec5.png";